<template>
  <div>
    <background-detail showpages="fourhundred"></background-detail>
  </div>
</template>

<script>
  import backgroundDetail from '../../../components/backgroundDetail.vue' 
  /**
  *@ClassName:400backgroundDetail
  *@Description:400报事详情
  *@author:孙斯维
  *@Copyright:格众科技
  *@date:2020-03-17
 */
   export default {
   components: {
      'background-detail': backgroundDetail 
    },
    data () {
      return {}
    },
    computed: {},
    watch: {},
    methods: {
    
  },
}
</script>
<style lang='scss'>
 
</style>
